export default {
  audio: null,
  video: null,
  isLoading: false,
};
